import { render, staticRenderFns } from "./website-tongji.vue?vue&type=template&id=4d50f5ff&scoped=true"
import script from "./website-tongji.vue?vue&type=script&lang=js"
export * from "./website-tongji.vue?vue&type=script&lang=js"
import style0 from "./website-tongji.vue?vue&type=style&index=0&id=4d50f5ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50f5ff",
  null
  
)

export default component.exports